import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'insight-card',
    templateUrl: './insight-card.component.html',
    styleUrls: ['./insight-card.component.scss'],
})
export class InsightCardComponent implements OnInit {
    @Input() insightLink: string;
    @Input() module: string;
    @Input() insightTitle: string;
    @Input() insightDescription: string;
    @Input() imageSource: string;
    @Input() isLocked?: boolean;

    constructor() {}

    ngOnInit() {}
}
